export {default} from '../patterngalleries/DesignerGallery';



// WEBPACK FOOTER //
// ./src/components/async/DesignerGallery.js